<template>
  <div id="filters" v-if="Object.entries(filters).length">

    <p class="text-2xl mb-0">Filters</p>
    <hr class="h-px bg-theme-darker mt-0 mb-2">

    <div v-for="(rule, i) in filters" :key="'filter-components-' + i">
      <filter-rules :rule="rule" @input="$emit('updated')"></filter-rules>
    </div>

    <div class="text-center text-sm mt-8" v-if="hasFilterChanges">
      <button class="btn btn-blue focus:outline-none" @click="reset">
        <i class="fas fa-eraser"></i>
        <span class="ml-2">Clear</span>
      </button>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
const FilterRules = resolve => require(['@/components/filters/Rules'], resolve)

export default {
  name: 'filters',
  props: {
    filters: {},
  },
  components: {
    FilterRules,
  },
  data() {
    return {
      initial: {},
      flatpickrConfig: {},
      rules: [],
    }
  },
  computed: {
    hasFilterChanges() {
      let initial = this.$getFilterValues(this.initial)
      let current = this.$getFilterValues(this.filters)
      let hasChanges = Object.keys(current).filter(i => initial[i] !== current[i]).length > 0
      this.$emit('has-changes', hasChanges)
      return hasChanges
    },
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    this.initial = _.cloneDeep(this.filters)
    this.setFilters(this.filters)
  },
  methods: {
    setFilters(filters) {
      // only allow filters to be an object
      if (typeof filters !== 'object' || filters === null) {
        return false
      }
      let iterate = Object.keys(filters)
      for (let i in iterate) {
        let _filter = filters[iterate[i]]
        this.$set(_filter, 'default', _filter.value)
        if (_filter.options) {
          this.$set(_filter, 'component', 'FilterSelect')
          if (_filter.options instanceof Function) {
            _filter.options = _filter.options()
          }
        } else if (_filter.flatpickr) {
          this.$set(_filter, 'component', 'FilterFlatpickr')
        } else if (_filter.modelSelect) {
          this.$set(_filter, 'component', 'FilterModelSelect')
        }

        if (_filter.children && Object.entries(_filter.children).length) {
          this.setFilters(_filter.children)
        }
      }
    },
    reset() {
      let filters = _.cloneDeep(this.initial)
      this.setFilters(filters)
      this.$emit('update:filters', filters)
      this.$emit('updated')
    },
  }
}
</script>
